import React, { useEffect, useState } from 'react'
import { Modal, Backdrop, Fade } from "@material-ui/core";
import { Typography, OutlinedInput, InputAdornment, Tooltip, Checkbox, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';
import { Popover, MenuItem } from "@material-ui/core";
import { getDatafromDataModelIdPayload } from '../../utils/payload'
import DataTable from '../DataTable/DataTable'

const useStyles = makeStyles(() => ({
    smallPagination: {
        "& .MuiTablePagination-caption": {
            flexShrink: 0,
            fontSize: "12px",
        },
        "& .MuiTablePagination-selectRoot": {
            fontSize: "12px",
        },
        "& .MuiTablePagination-displayedRows": {
            fontSize: "12px",
        },
        "& .MuiTablePagination-actions .MuiIconButton-root": {
            padding: "4px",
        },
        "& .MuiTablePagination-actions svg": {
            fontSize: "16px",
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: '#fff',
        boxShadow: 'none',
    },

    /* Inputs */
    inputRoot: {
        height: '32px',
        padding: '5px 8px 6px 8px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    },
    inputRoot1: {
        height: '32px',
        width: '250px',
        padding: '5px 8px 6px 8px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    },
    inputText: {
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
    },

    /* Modal layout */
    modalContainer: {
        height: 760,
        width: 800,
        borderRadius: 8,
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        margin: 'auto',
        outline: 'none',
    },
    headerBar: {
        height: 50,
        padding: '16px 10px',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 10,
        borderBottom: '1px solid #E0E0E0'
    },
    headerTitle: {
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        color: 'rgba(33, 33, 33, 1)'
    },
    selectedCount: {
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        color: 'rgba(63, 81, 181, 1)'
    },
    sectionContainer: {
        padding: 16,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        borderBottom: '1px solid #E0E0E0'
    },
    topRow: {
        height: 55,
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10
    },
    columnGap6: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6
    },
    mutedLabel: {
        fontSize: 12,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(146, 147, 166, 1)'
    },

    /* Filters row scroller */
    filtersScroller: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 10,
        maxWidth: 500,
        overflowX: 'auto',
        overflowY: 'hidden',
        flexWrap: 'nowrap',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    filterField: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        minWidth: 120,
        flexShrink: 0,
    },

    /* Icons */
    searchIcon: {
        fontSize: 19,
        cursor: 'pointer',
        color: 'rgba(95, 96, 113, 1)'
    },
    searchIconSmall: {
        fontSize: 14,
        color: 'rgba(95, 96, 113, 1)'
    },

    /* Popover */
    popoverPaper: (props) => ({
        boxShadow: 'none',
        border: '1px solid rgba(213, 214, 221, 1)',
        marginTop: 2,
        width: props?.popoverWidth || 'auto',
    }),
    popoverContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    popoverSearchWrapper: {
        padding: 6
    },
    popoverSearchInput: {
        marginBottom: 4,
        width: '100%'
    },
    popoverList: {
        maxHeight: 200,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    menuItem: {
        boxShadow: 'none',
        fontSize: 12,
        padding: 0,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(146, 147, 166, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 160
    },
    menuItemBold: {
        fontWeight: 500
    },
    optionLabel: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        maxWidth: '100%'
    },
    buttonRow: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        height: 50,
        boxSizing: 'border-box',
        gap: 10,
        padding: '12px 16px'
    },
    btnOutlineSmall: {
        height: 14,
        width: 40,
        padding: 10,
        backgroundColor: 'transparent',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(63, 81, 181, 1)',
        fontSize: 11,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: 'transparent',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },

    },
    btnPrimarySmall: {
        height: 14,
        width: 40,
        padding: 10,
        backgroundColor: '#3F51B5',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(255, 255, 255, 1)',
        fontSize: 11,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: '#3F51B5',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },
    },

    /* Loader & table scroll */
    loaderContainer: {
        minHeight: 768,
        overflowY: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    tableScroll: {
        maxHeight: 500,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    paginationContainer: {
        marginTop: 5
    },

    /* Footer buttons */
    footerBar: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        height: 50,
        boxSizing: 'border-box',
        gap: 10,
        padding: '12px 16px'
    },
    btnOutline: {
        height: 38,
        width: 68,
        padding: '12px 16px',
        backgroundColor: 'transparent',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(63, 81, 181, 1)',
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: 'transparent',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },
    },
    btnPrimary: {
        height: 38,
        width: 150,
        padding: '12px 16px',
        backgroundColor: '#3F51B5',
        borderRadius: 4,
        border: '1px solid #3F51B5',
        color: 'rgba(255, 255, 255, 1)',
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '21px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: '#3F51B5',
            borderColor: '#3F51B5',
            boxShadow: 'none',
        },
    },
}));

const ModelWithTableViewer = (props) => {
    const { formData, open, handleCloseModel, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, selectedOptions, menuOptions, keyVal, chartUniqueId, appId, block, parentBlockState } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useStyles({ popoverWidth: anchorEl?.clientWidth });

    const [blockState, setBlockState] = useState([])
    const [totalRecords, setTotalRecords] = React.useState(0);
    const [blockHeaders, setBlockHeaders] = useState([])
    const [selectedDocuments, setSelectedDocuments] = useState([])

    const [filterConditions, setFilterConditions] = useState([])

    const [filterDropdownData, setFilterDropdownData] = useState([]);

    const [currentFilterField, setCurrentFilterField] = useState(null);

    const [selectedFilterOptions, setSelectedFilterOptions] = useState({});

    const [filterSearchTerm, setFilterSearchTerm] = useState('');

    const [mainSearchTerm, setMainSearchTerm] = useState('');

    const [dateFilterValues, setDateFilterValues] = useState({});
    const [dateFilterAnchorEl, setDateFilterAnchorEl] = useState(null);
    const [currentDateFilterField, setCurrentDateFilterField] = useState(null);


    console.log('ModelWithTableViewer**blockState', blockState, props)

    // Function to handle main search input change
    const handleMainSearchChange = (event) => {
        setMainSearchTerm(event.target.value);
    };

    // Function to handle main search
    const handleMainSearch = () => {
        getDatafromDataModelId(mainSearchTerm);
    };

    // Function to handle search on Enter key press
    const handleMainSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleMainSearch();
        }
    };

    // Function to handle search icon click
    const handleSearchIconClick = () => {
        handleMainSearch();
    };

    // const columnsss = [
    //     "checkbox",
    //     "File Name",
    //     "Contract Type",
    //     "Effective Date",
    //     "Expiration Date",
    // ];
    // const rowsss = [
    //     {
    //         fileName: "Partnership Agreement for Innovative Solutions",
    //         contractType: "MSA",
    //         effectiveDate: "06-02-2012",
    //         expirationDate: "06-02-2028",
    //     },
    //     {
    //         fileName: "Service Level Agreement for Cloud Hosting",
    //         contractType: "SLA",
    //         effectiveDate: "01-10-2018",
    //         expirationDate: "01-10-2025",
    //     },
    //     {
    //         fileName: "Non-Disclosure Agreement with Vendor X",
    //         contractType: "NDA",
    //         effectiveDate: "15-05-2020",
    //         expirationDate: "15-05-2026",
    //     },
    //     {
    //         fileName: "Consulting Services Agreement - ABC Corp",
    //         contractType: "CSA",
    //         effectiveDate: "22-07-2017",
    //         expirationDate: "22-07-2024",
    //     },
    //     {
    //         fileName: "Software License Agreement - Product Suite",
    //         contractType: "License",
    //         effectiveDate: "10-03-2019",
    //         expirationDate: "10-03-2029",
    //     },
    //     {
    //         fileName: "Employment Contract - Senior Developer",
    //         contractType: "Employment",
    //         effectiveDate: "05-01-2021",
    //         expirationDate: "05-01-2026",
    //     },
    //     {
    //         fileName: "Vendor Agreement - Office Supplies",
    //         contractType: "Vendor",
    //         effectiveDate: "30-09-2015",
    //         expirationDate: "30-09-2025",
    //     },
    //     {
    //         fileName: "Research Collaboration Agreement - University Z",
    //         contractType: "Research",
    //         effectiveDate: "18-11-2014",
    //         expirationDate: "18-11-2024",
    //     },
    //     {
    //         fileName: "Franchise Agreement - Location Y",
    //         contractType: "Franchise",
    //         effectiveDate: "27-04-2016",
    //         expirationDate: "27-04-2031",
    //     },
    //     {
    //         fileName: "Joint Venture Agreement - Tech Partners",
    //         contractType: "JV",
    //         effectiveDate: "09-08-2013",
    //         expirationDate: "09-08-2028",
    //     }
    // ];

    console.log("ModelWithTableViewer props ===> ", blockHeaders, blockState, totalRecords, props, filterDropdownData, filterConditions);

    const handleClose = () => { if (props.isCallingoutside === null || props.isCallingoutside === undefined || props.isCallingoutside === false) { props.onEditModeChange(false); } setAnchorEl(null) };

    const getFilteredDropdownData = () => {
        if (!filterSearchTerm) {
            return filterDropdownData;
        }

        return filterDropdownData.filter(option => {
            if (!option || !option.label) {
                return false;
            }
            return option?.label.toLowerCase().includes(filterSearchTerm.toLowerCase())
        }
        );
    };

    const handleFilterSearchChange = (event) => {
        setFilterSearchTerm(event.target.value);
    };

    const handleDateFilterChange = (e, filterValue) => {
        const value = e.target.value;
        console.log("handleDateFilterChange ===> ", e.target.value, filterValue);

        setDateFilterValues(prev => ({
            ...prev,
            [filterValue.value]: value
        }));

        const existingCondition = filterConditions.find(condition =>
            condition.selectedConditionDataElement === filterValue.value &&
            condition.value === value
        );

        if (existingCondition) {
            if (setFilterConditions) {
                setFilterConditions(prev =>
                    prev.filter(condition =>
                        !(condition.selectedConditionDataElement === filterValue.value &&
                            condition.value === value)
                    )
                );
            }
        } else {
            const newFilterCondition = {
                selectedConditionDataElement: filterValue.value,
                selectedConditionOperator: "between",
                value: value,
                selectedConditionClause: "and"
            };

            if (setFilterConditions) {
                setFilterConditions(prev => {
                    const filteredConditions = prev.filter(condition =>
                        condition.selectedConditionDataElement !== filterValue.value
                    );
                    return [...filteredConditions, newFilterCondition];
                });
            }
        }
    };

    const getDateFilterDisplayText = (filterField) => {
        const dateValues = dateFilterValues[filterField.value] || {};
        if (dateValues) {
            return dateValues;
        }
        return "Select";
    };

    const handleFilterClick = (event, filterField) => {
        setCurrentFilterField(filterField);
        setAnchorEl(event.currentTarget);
        setFilterSearchTerm('');
        if (!(formData?.externalFilterData?.[chartUniqueId + '_externalFilter_' + filterField?.value])) {
            fetchFilterData(filterField);
        }
        else {
            let dataList = formData?.externalFilterData?.[chartUniqueId + '_externalFilter_' + filterField?.value] || []
            setFilterDropdownData(dataList)
        }
    };

    const fetchFilterData = (filterField) => {
        let payloadForDropDown = {
            appId: appId,
            id: block.dataModel || keyVal,
            rowsPerPage: "all",
            conditions: []
        };
        payloadForDropDown.field = filterField.value;
        payloadForDropDown['dataUniqueId'] = chartUniqueId + '_externalFilter' + '_' + filterField.value;

        props.getModelDataDropDown({
            ...payloadForDropDown,
            dataUniqueId: payloadForDropDown['dataUniqueId']
        });
    };

    const handleFilterOptionSelect = (filterField, option, isSelected) => {
        setSelectedFilterOptions(prev => {
            const currentField = prev[filterField.value] || [];
            let updatedField;

            if (isSelected) {
                if (!currentField.includes(option.value)) {
                    updatedField = [...currentField, option.value];
                } else {
                    updatedField = currentField;
                }
            } else {
                updatedField = currentField.filter(val => val !== option.value);
            }

            return {
                ...prev,
                [filterField.value]: updatedField
            };
        });
    };

    const handleFilterSelectAll = (filterField, isSelected) => {
        if (isSelected) {
            const allValues = filterDropdownData.map(option => option.value);
            setSelectedFilterOptions(prev => ({
                ...prev,
                [filterField.value]: allValues
            }));
        } else {
            setSelectedFilterOptions(prev => ({
                ...prev,
                [filterField.value]: []
            }));
        }
    };

    const isFilterAllSelected = (filterField) => {
        const selectedValues = selectedFilterOptions[filterField.value] || [];
        return filterDropdownData.length > 0 && selectedValues.length === filterDropdownData.length;
    };

    const isFilterIndeterminate = (filterField) => {
        const selectedValues = selectedFilterOptions[filterField.value] || [];
        return selectedValues.length > 0 && selectedValues.length < filterDropdownData.length;
    };

    const handleFilterSave = () => {
        const newFilterConditions = [];

        Object.keys(selectedFilterOptions).forEach(fieldKey => {
            const selectedValues = selectedFilterOptions[fieldKey];
            if (selectedValues && selectedValues.length > 0) {
                const filterField = block?.config[0]?.externalFilter?.find(f => f.value === fieldKey);
                if (filterField) {
                    newFilterConditions.push({
                        selectedConditionDataElement: fieldKey,
                        selectedConditionOperator: "in",
                        value: selectedValues,
                        selectedConditionClause: "and"
                    });
                }
            }
        });

        if (setFilterConditions) {
            setFilterConditions(newFilterConditions);
        }

        handleClose();
    };

    const isFilterOptionSelected = (filterField, option) => {
        const selectedValues = selectedFilterOptions[filterField.value] || [];
        return selectedValues.includes(option.value);
    };

    useEffect(() => {
        if (formData?.externalFilterData?.[chartUniqueId + '_externalFilter_' + currentFilterField?.value]) {
            let dataList = formData?.externalFilterData[chartUniqueId + '_externalFilter_' + currentFilterField?.value] || []
            setFilterDropdownData(dataList)
        }

    }, [formData?.externalFilterData?.[chartUniqueId + '_externalFilter_' + currentFilterField?.value]]);


    const isAllSelected = blockState.length > 0 && selectedDocuments.length === blockState.length;
    const isIndeterminate = selectedDocuments.length > 0 && selectedDocuments.length < blockState.length;

    const getDatafromDataModelId = (searchKey) => {
        let modelDatapayload = getDatafromDataModelIdPayload(appId, keyVal, page, rowsPerPage, filterConditions)
        if (searchKey) {
            modelDatapayload['search'] = searchKey;
        }
        props.getModelData({ ...modelDatapayload, dataUniqueId: chartUniqueId + '_assosiateddata' });
    }

    useEffect(() => {
        getDatafromDataModelId()
    }, [page, rowsPerPage, filterConditions])

    const handleDocumentSelection = (documentId, dataModel, isSelected) => {
        if (isSelected) {
            setSelectedDocuments(prev => {
                const newSelected = [...prev];
                const existingIndex = newSelected.findIndex(doc => doc.id === documentId);

                if (existingIndex === -1) {
                    newSelected.push({
                        id: documentId,
                        dataModel: dataModel
                    });
                }

                return newSelected;
            });
        } else {
            setSelectedDocuments(prev => prev.filter(doc => doc.id !== documentId));
        }
    }

    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allDocuments = blockState.map(row => ({
                id: row.id || row._id || row.documentId,
                dataModel: block.dataModel || keyVal
            }));
            setSelectedDocuments(allDocuments);
        } else {
            setSelectedDocuments([]);
        }
    }

    const handleSaveDocuments = () => {
        const existingLinkedRefs = parentBlockState?.linkedReferenceDocument || [];

        const documentsByDataModel = {};
        selectedDocuments.forEach(doc => {
            if (!documentsByDataModel[doc.dataModel]) {
                documentsByDataModel[doc.dataModel] = [];
            }
            documentsByDataModel[doc.dataModel].push(doc.id);
        });

        const newLinkedReferenceDocument = [...existingLinkedRefs];

        Object.keys(documentsByDataModel).forEach(dataModel => {
            const documentIds = documentsByDataModel[dataModel];

            const existingIndex = newLinkedReferenceDocument.findIndex(item => item.dataModel === dataModel);

            if (existingIndex !== -1) {
                const existingDocs = newLinkedReferenceDocument[existingIndex].documents || [];
                const mergedDocs = [...new Set([...existingDocs, ...documentIds])];
                newLinkedReferenceDocument[existingIndex] = {
                    ...newLinkedReferenceDocument[existingIndex],
                    documents: mergedDocs
                };
            } else {
                newLinkedReferenceDocument.push({
                    dataModel: dataModel,
                    documents: documentIds
                });
            }
        });

        if (props.isCallingoutside === null || props.isCallingoutside === undefined || props.isCallingoutside === false) {
            if (props.setBlockState) {
                props.setBlockState({
                    ...parentBlockState,
                    linkedReferenceDocuments: newLinkedReferenceDocument
                });
            }

            if (props.match?.params?.id && props.onEditModeChange) {
                props.onEditModeChange(true);
            }
        }
        else {
            props.handleSaveDocumentsOutside(newLinkedReferenceDocument, selectedDocuments);
        }

        // if (props.match?.params?.id && props.onEditModeChange) {
        //     props.onEditModeChange(true);
        // }

        handleCloseModel();
    }

    const initializeSelectedDocuments = () => {
        if (parentBlockState?.linkedReferenceDocuments) {
            const existingSelected = [];
            parentBlockState.linkedReferenceDocuments.forEach(item => {
                if (item.dataModel === block.dataModel && item.documents) {
                    item.documents.forEach(docId => {
                        existingSelected.push({
                            id: docId,
                            dataModel: item.dataModel
                        });
                    });
                }
            });
            setSelectedDocuments(existingSelected);
        }
        else {
            setSelectedDocuments([]);
        }
    };

    useEffect(() => {
        if (open) {
            initializeSelectedDocuments();
        }
    }, [open, parentBlockState]);

    useEffect(() => {
        if (formData?.dataModel[block.dataModel || selectedStep.dataModel]) {
            let dataElements = formData.dataModel[block.dataModel || selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                console.log("Cmng here 000 ===> ", block?.config[0]?.dataElements, block?.config[0]?.dataElements?.length);
                if (block?.config[0]?.dataElements) {
                    console.log("Cmng here 000 ===> ", block?.config[0]?.dataElements, dataElements);
                    fdes = JSON.parse(JSON.stringify(block?.config[0]?.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return {
                                ...sde,
                                ...fde
                            }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                    console.log("Fdes 000 ===> ", fdes);
                }
            }
        }
    }, [keyVal])


    useEffect(() => {
        if (formData?.document[chartUniqueId + '_assosiateddata']?.data?.length) {
            let dataList = formData?.document[chartUniqueId + '_assosiateddata']?.data || []
            let total = formData?.document[chartUniqueId + '_assosiateddata']?.total || []
            setBlockState(dataList)
            setTotalRecords(total)

        } else {
            setBlockState([])
            setTotalRecords(0)
        }
    }, [props.formData?.document[chartUniqueId + '_assosiateddata']])

    useEffect(() => {
        getDatafromDataModelId()
    }, [keyVal])

    const cellStyle = {
        padding: '8px',
        border: '1px solid rgba(233, 235, 245, 1)',
    };

    const cellStyle23 = {
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(95, 96, 113, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px',
    }

    const cellStyle1 = {
        padding: '8px',
        fontSize: '12px',
        fontWeight: '500',
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(95, 96, 113, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 80,
        border: '1px solid rgba(233, 235, 245, 1)',
    };

    const getFilterDisplayText = (filterField) => {
        const selectedValues = selectedFilterOptions[filterField.value] || [];

        if (selectedValues.length === 0) {
            return "Select";
        }

        const filterData = formData?.externalFilterData?.[chartUniqueId + '_externalFilter_' + filterField?.value] || [];

        if (selectedValues.length === 1) {
            const selectedOption = filterData.find(option => option.value === selectedValues[0]);
            return selectedOption ? selectedOption.label : "Select";
        }

        if (selectedValues.length > 1) {
            const firstSelectedOption = filterData.find(option => option.value === selectedValues[0]);
            const firstLabel = firstSelectedOption ? firstSelectedOption.label : "Select";
            const maxLength = 15;
            const truncatedLabel = firstLabel.length > maxLength
                ? firstLabel.substring(0, maxLength) + '...'
                : firstLabel;

            return `${truncatedLabel} +${selectedValues.length - 1}`;
        }

        return "Select";
    };

    return (
        <Modal
            open={open}
            onClose={handleCloseModel}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={open}>
                <div className={classes.modalContainer}>
                    <div className={classes.headerBar}>
                        <Typography className={classes.headerTitle}>
                            Select Document
                        </Typography>

                        {selectedDocuments.length > 0 && (
                            <Typography className={classes.selectedCount}>
                                {selectedDocuments.length} Document{selectedDocuments.length !== 1 ? 's' : ''} Selected
                            </Typography>
                        )}
                    </div>

                    <div className={classes.sectionContainer}>
                        <div className={classes.topRow}>
                            {
                                block?.config[0]?.isSearch && (
                                    <div className={classes.columnGap6}>
                                        <Typography className={classes.mutedLabel}>
                                            Search
                                        </Typography>
                                        <OutlinedInput
                                            variant="outlined"
                                            classes={{ root: classes.inputRoot1 }}
                                            value={mainSearchTerm}
                                            onChange={handleMainSearchChange}
                                            onKeyPress={handleMainSearchKeyPress}
                                            inputProps={{ className: classes.inputText }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <Search
                                                        className={classes.searchIcon}
                                                        onClick={handleSearchIconClick}
                                                    />
                                                </InputAdornment>
                                            }
                                            placeholder={"Search Here ..."}
                                        />
                                    </div>
                                )
                            }

                            {
                                block?.config[0]?.isFilter && (
                                    <div className={`myScrollContainer ${classes.filtersScroller}`}>
                                        {
                                            block?.config[0]?.externalFilter && block?.config[0]?.externalFilter?.map((idx, index) => {
                                                return (
                                                    <div key={index} className={classes.filterField}>
                                                        <Typography className={classes.mutedLabel}>
                                                            {idx.label}
                                                        </Typography>
                                                        <OutlinedInput
                                                            variant="outlined"
                                                            classes={{ root: classes.inputRoot }}
                                                            type={idx.type}
                                                            value={idx.type === 'date' ? getDateFilterDisplayText(idx) : getFilterDisplayText(idx)}
                                                            inputProps={{ className: classes.inputText }}
                                                            placeholder={"Select"}
                                                            onClick={(e) => {
                                                                if (idx.type === 'string') {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    handleFilterClick(e, idx)
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                if (idx.type === 'date') {
                                                                    handleDateFilterChange(e, idx)
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }
                                                            }}
                                                        />

                                                        <Popover
                                                            open={Boolean(anchorEl)}
                                                            anchorEl={anchorEl}
                                                            disableRestoreFocus
                                                            PaperProps={{ className: classes.popoverPaper }}
                                                            onClose={(event, reason) => {
                                                                if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
                                                                    return;
                                                                }
                                                                handleClose();
                                                            }}
                                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                        >
                                                            <div className={classes.popoverContainer}>
                                                                <div className={classes.popoverSearchWrapper}>
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        classes={{ root: classes.inputRoot }}
                                                                        placeholder="Search..."
                                                                        inputProps={{ className: classes.inputText }}
                                                                        value={filterSearchTerm}
                                                                        onChange={handleFilterSearchChange}
                                                                        endAdornment={
                                                                            <InputAdornment position="end">
                                                                                <Search className={classes.searchIconSmall} />
                                                                            </InputAdornment>
                                                                        }
                                                                        className={classes.popoverSearchInput}
                                                                    />
                                                                </div>

                                                                <div className={`myScrollContainer ${classes.popoverList}`}>
                                                                    {currentFilterField && getFilteredDropdownData().length > 0 && (
                                                                        <MenuItem className={classes.menuItem}>
                                                                            <Checkbox
                                                                                size='small'
                                                                                checked={isFilterAllSelected(currentFilterField)}
                                                                                indeterminate={isFilterIndeterminate(currentFilterField)}
                                                                                onChange={(e) => handleFilterSelectAll(currentFilterField, e.target.checked)}
                                                                            />
                                                                            <span className={classes.menuItemBold}>Select All</span>
                                                                        </MenuItem>
                                                                    )}

                                                                    {currentFilterField && getFilteredDropdownData().map((option, idx) => (
                                                                        <MenuItem key={idx} className={classes.menuItem}>
                                                                            <Checkbox
                                                                                size='small'
                                                                                checked={isFilterOptionSelected(currentFilterField, option)}
                                                                                onChange={(e) => handleFilterOptionSelect(currentFilterField, option, e.target.checked)}
                                                                            />
                                                                            <Tooltip title={option.label} arrow>
                                                                                <span className={classes.optionLabel}>
                                                                                    {option.label}
                                                                                </span>
                                                                            </Tooltip>
                                                                        </MenuItem>
                                                                    ))}
                                                                </div>

                                                                <div className={classes.buttonRow}>
                                                                    <Button variant="contained" className={classes.btnOutlineSmall} onClick={() => { handleClose() }}>Close</Button>
                                                                    <Button variant="contained" className={classes.btnPrimarySmall} onClick={handleFilterSave}>Save</Button>
                                                                </div>
                                                            </div>
                                                        </Popover>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }

                        </div>

                        <div>
                            {
                                (props.formData?.[chartUniqueId + '_assosiateddata_loading'] || props.formData?.[(block.dataModel || selectedStep.dataModel) + '_loading']) ? (
                                    <div className={`myScrollContainer ${classes.loaderContainer}`}>
                                        {props.loader}
                                    </div>
                                ) : (
                                    <div>
                                        <div className={`myScrollContainer ${classes.tableScroll}`}>
                                            <DataTable
                                                headers={blockHeaders}
                                                data={blockState}
                                                showCheckbox={true}
                                                selectedItems={selectedDocuments.map(doc => doc.id)}
                                                onSelectionChange={(documentId, isSelected) => {
                                                    handleDocumentSelection(documentId, block.dataModel || keyVal, isSelected);
                                                }}
                                                onSelectAll={handleSelectAll}
                                                page={page}
                                                rowsPerPage={rowsPerPage}
                                                totalRecords={totalRecords}
                                                showPagination={false}
                                                onPageChange={handleChangePage}
                                                uniqueId={789}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                match={props.match} 
                                                history={props.history}
                                            />
                                        </div>
                                        <div className={classes.paginationContainer}>
                                            <TablePagination
                                                component="div"
                                                count={totalRecords}
                                                className={classes.smallPagination}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className={classes.footerBar}>
                        <Button variant="contained" className={classes.btnOutline} onClick={() => { handleCloseModel() }}>Close</Button>
                        <Button variant="contained" className={classes.btnPrimary} onClick={handleSaveDocuments}>Add Document</Button>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModelWithTableViewer
